import React, { useEffect, useState } from 'react';

const GameOverModal = ({ stats, onPlayAgain, deviceInfo }) => {
  const [confetti, setConfetti] = useState([]);

  // Create confetti effect
  useEffect(() => {
    const createConfetti = () => {
      const newConfetti = [];
      for (let i = 0; i < 50; i++) {
        setTimeout(() => {
          const confettiPiece = {
            left: Math.random() * 100,
            emoji: ['🎉', '🎊', '⭐', '💫', '✨'][Math.floor(Math.random() * 5)],
            animationDelay: i * 100
          };
          setConfetti(prev => [...prev, confettiPiece]);
        }, i * 100);
      }
    };

    createConfetti();

    // Clean up confetti after animation
    const cleanup = setTimeout(() => {
      setConfetti([]);
    }, 4000);

    return () => clearTimeout(cleanup);
  }, []);

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>🎉 YOU WIN! 🎉</h2>
        {deviceInfo && (
          <div className="winner-info">
            <p>🏆 Congratulations, <strong>{deviceInfo.firstName} {deviceInfo.lastName}!</strong></p>
          </div>
        )}
        <p>You reached the client in <span>{stats.time}</span> seconds!</p>
        <p>Total taps: <span>{stats.taps}</span></p>
        <p>Average speed: <span>{stats.avgSpeed.toFixed(2)}</span> TPS</p>
        <button className="btn btn-primary" onClick={onPlayAgain}>
          PLAY AGAIN
        </button>
      </div>
      
      {/* Confetti */}
      {confetti.map(piece => (
        <div
          key={piece.id}
          style={{
            position: 'fixed',
            left: `${piece.left}vw`,
            top: '-50px',
            fontSize: '2rem',
            pointerEvents: 'none',
            zIndex: 1001,
            animation: 'fall 3s linear forwards',
            animationDelay: `${piece.animationDelay}ms`
          }}
        >
          {piece.emoji}
        </div>
      ))}
    </div>
  );
};

export default GameOverModal;
